import { FIREBASE_NOTIFICATION_COOKIE } from 'config/cookie';
import moment from 'moment';
import { cookiesInstance } from './cookiesInstance';

export const set = (days: number) => {
  const expirationDate = moment().add(days, 'days').toDate();
  cookiesInstance.set(FIREBASE_NOTIFICATION_COOKIE, 'enabled', {
    expires: expirationDate
  });
};

export const get = () => {
  const firebaseToken = cookiesInstance.get(FIREBASE_NOTIFICATION_COOKIE);
  return firebaseToken;
};

export const remove = () => cookiesInstance.remove(FIREBASE_NOTIFICATION_COOKIE);
